import React, {useContext, useState} from "react"
import PropTypes from "prop-types"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import slugify from "slugify"
import Link from "next/link"
import Image from "next/image"
import classes from "./CatTabItem.module.scss"
import LayoutContext from "../../../context/LayoutContext"

type Props = {
    label: string,
	isActive: boolean
	setActive: (tabId: number)=>void
	urlBase: string
	img: string
	id: number
	imgActive: string
}

const CatTabItem: React.FC<Props> = ({label, isActive, urlBase, img, id, setActive, imgActive}) => {
	const [isHover, setIsHover] = useState(false)
	const {t} = useTranslation("consultationPage")
	const {isMobile} = useContext(LayoutContext)
	const handleClick = () => {
		setActive(id)
	}

	return (
		<li onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			className={"col-12 col-md-2 ms-0 ms-md-0"}>
			<div className={`${isMobile && "border-start border-4"} ${isActive && "border-primary border-4"} ${isActive && !isMobile && "border-bottom border-primary border-4"}`}>
				<Link href={`${t(urlBase)}/${slugify(`${t(label).toLowerCase()}`)}`}
					scroll={false}
					shallow = {true}>
					<a onClick={handleClick}
						className={"nav-link border-0 px-0 d-flex align-items-center flex-row flex-md-column"}>
						<span className={`${classes.imageWraper}`}>
							<span className={`${classes.imageBackground} ${isHover || isActive ? classes.imageBackgroundHover : ""} py-2 px-0 px-lg-4`}>
								<span className={`position-relative d-inline-block ${classes.image}`} >
									<Image src={isActive ? imgActive : img}
										layout="fill"
										objectFit="contain"/>
								</span>
							</span>
						</span>
						<Typography variant="bodyLgBold"
							semanticTag="span"
							className={"text-md-nowrap text-md-center ms-4 ms-md-0 mt-0 m-md-3 mt-lg-0 mb-lg-0 text-black"}>
							{t(label)}
						</Typography>
					</a>
				</Link>
			</div>
		</li>
	)
}

CatTabItem.propTypes = {
	label: PropTypes.string.isRequired,
	isActive: PropTypes.bool.isRequired,
	setActive: PropTypes.func.isRequired,
	urlBase: PropTypes.string.isRequired
}

export default CatTabItem
// Old markup for component
// 	return (
// 		<li onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)} className="col-12 col-md-2 ms-0 ms-md-0 mb-3">
// 			<Link href={`${t(urlBase)}/${slugify(`${t(label).toLowerCase()}`)}`} scroll={false} shallow = {true}>
// 				<a onClick={handleClick} className={"nav-link border-0 px-0 d-flex align-items-center flex-row flex-md-column"}>
// 					<span className={`${classes.imageWraper} ${isActive ? "bg-primary" : "bg-light"}`}>
// 						<span className={`${classes.imageBackground} ${isHover || isActive ? classes.imageBackgroundHover : ""} ${isActive ? "bg-primary" : "bg-light"} py-2 px-4`}>
// 							<span className={`position-relative d-inline-block ${classes.image}`} >
// 								<Image src={img} layout="fill" objectFit="contain"/>
// 							</span>
// 						</span>
// 					</span>
// 					<Typography variant="bodyLgBold" semanticTag="span" className={`text-md-nowrap text-md-center ms-4 ms-md-0 mt-0 m-md-3 ${isActive ? "text-dark active border-primary border-bottom border-4" : "text-secondary"}`}>
// 						{t(label)}
// 					</Typography>
// 				</a>
// 			</Link>
// 		</li>
// 	)
// }
